import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".HeaderContainer-module_container__YGHlv{align-items:center;background:var(--page-primary-background);box-shadow:0 1px 0 rgb(var(--neutral-black-raw)/.05);box-sizing:border-box;display:flex;height:56px;padding:var(--padding-sm);position:sticky;top:0;z-index:var(--layer-header)}";
var style = {"container":"HeaderContainer-module_container__YGHlv"};
styleInject(css_248z);

export { style as default };
//# sourceMappingURL=HeaderContainer.module.css.js.map
